export const LOGIN = '/login';
export const REGISTER = '/register';
export const FORGOTTEN_PASSWORD = '/forgotten-password';
export const RESET_PASSWORD = '/reset-password/:token';
export const VERIFY_EMAIL = '/verify-email';

export const DASHBOARD = '/dashboard';
export const PRODUCTS = '/variants/';
export const PRODUCTS_ALL = '/variants/all';
export const PRODUCT_CATEGORIES = '/products/categories';
export const PRODUCTS_EDIT = '/variants/edit/:id';
export const INVENTORY = '/inventory';
export const ORDERS = '/orders';
export const ORDERS_ALL = '/orders/all';
export const ORDERS_STOREFRONT = '/orders/storefront';
export const EXPENSES = '/expenses';
export const ASSETS = '/assests';
export const CERTIFICATIONS = '/certifications';
export const SHOP_SELECTOR = '/shop-selector';
export const USER_MANAGEMENT = '/user-management';
export const ACCOUNT = '/account';
export const ACTIVITY_LOGS = '/activity-logs';
export const CUSTOMERS = '/customers';
export const CUSTOMERS_ALL = '/customers/all';
export const CUSTOMER_GROUPS = '/customers/groups';
export const CUSTOMER_GROUP_REPORTS = '/customers/groups/:id/reports';
export const NOT_FOUND = '/not-found';
export const INVOICE = '/invoice';
export const SUBSCRIPTION = '/subscription/manage';
export const SUBSCRIPTION_CALLBACK = '/subscription/callback';

export const LANDING_PAGE = '/';
export const STOREFRONT = '/storefront';
